import InputTypes from '../../../core/enums/InputTypes';

export const inputsIndicador = [
    {
        name: 'orgao',
        label: 'Órgão/Entidade',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'orgao.descOrgao' },
        export: { use: true, nameUse: 'orgao.descOrgao' },
        form: { use: true, validate: { required: true } },
        filter: { use: true, nameUse: 'orgao.idenOrgao' },
    },
    {
        name: 'codgIndicador',
        label: 'Código',
        type: InputTypes.STRING,
        table: { use: true },
        export: { use: true },
        filter: { use: true },
    },
    {
        name: 'nmIndicador',
        label: 'Nome',
        type: InputTypes.STRING,
        table: { use: true },
        export: { use: true },
        filter: { use: true },
    },
    {
        name: 'numrVersao',
        label: 'Versão',
        type: InputTypes.STRING,
        table: { use: true },
        export: { use: true },
    },
    {
        name: 'tipoIndicador',
        label: 'Tipo de Indicador',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'tipoIndicador.descTipoIndicador' },
        export: { use: true, nameUse: 'tipoIndicador.descTipoIndicador' },
        filter: { use: true, nameUse: 'tipoIndicador.id' },
    },
    {
        name: 'responsavel',
        label: 'Responsável',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'responsavel.nomePessoa' },
        export: { use: true, nameUse: 'responsavel.nomePessoa' },
        filter: { use: true, nameUse: 'responsavel.nomePessoa', useLike: true },
    },
    {
        name: 'dataProximaApuracao',
        label: 'Próxima Apuração',
        type: InputTypes.DATE,
        table: { use: true },
        export: { use: true },
    },
    {
        name: 'situacao',
        label: 'Situação',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'situacaoIndicador.descSituacaoIndicador' },
        export: { use: true, nameUse: 'situacaoIndicador.descSituacaoIndicador' },
        filter: { use: true, nameUse: 'situacaoIndicador.id' },
    },
];
